import { YDR_PROTOCOL } from "@/common/consts";

import importedDictionary from "./imported/en.js";

const env = process.env.NODE_ENV !== "production" ? `${process.env.NODE_ENV}.` : "";

const en = Object.assign(importedDictionary, {
	// Below this is stuff manually created during WFW-380 and is not part of the Google Doc.
	HeaderDictionaryText: "Dictionary",
	HeaderDictionaryUrl: `${YDR_PROTOCOL}//www.${env}yourdictionary.com/dictionary-definitions/`,
	HeaderThesaurusText: "Thesaurus",
	HeaderThesaurusUrl: `${YDR_PROTOCOL}//thesaurus.${env}yourdictionary.com/`,
	HeaderExamplesText: "Examples",
	HeaderExamplesUrl: `${YDR_PROTOCOL}//examples.${env}yourdictionary.com/`,
	HeaderSeeSentenceText: "See in a sentence",
	HeaderSeeSentenceUrl: `${YDR_PROTOCOL}//sentence.${env}yourdictionary.com/`,
	HeaderExampleArticlesText: "Example articles",
	HeaderExampleArticlesUrl: `${YDR_PROTOCOL}//examples.${env}yourdictionary.com/`,
	HeaderQuotesText: "Quotes",
	HeaderQuotesUrl: `${YDR_PROTOCOL}//quotes.${env}yourdictionary.com/`,
	HeaderFamousQuotesText: "Famous Quotes",
	HeaderFamousQuotesUrl: `${YDR_PROTOCOL}//quotes.${env}yourdictionary.com/`,
	HeaderQuotesArticlesText: "Quotes articles",
	HeaderQuotesArticlesUrl: `${YDR_PROTOCOL}//quotes.${env}yourdictionary.com/articles/`,
	HeaderSpanishText: "Spanish",
	HeaderSpanishUrl: `${YDR_PROTOCOL}//spanish.${env}yourdictionary.com/`,
	HeaderSpanishEnglishTranslationText: "Spanish-English Translation",
	HeaderSpanishEnglishTranslationUrl: `${YDR_PROTOCOL}//spanish.${env}yourdictionary.com/`,
	HeaderSpanishReferenceText: "Reference",
	HeaderSpanishReferenceUrl: `${YDR_PROTOCOL}//spanish.${env}yourdictionary.com/spanish-language/`,
	HeaderReferenceText: "Reference",
	HeaderReferenceUrl: `${YDR_PROTOCOL}//reference.${env}yourdictionary.com/`,
	HeaderEducationText: "Education",
	HeaderEducationUrl: `${YDR_PROTOCOL}//education.${env}yourdictionary.com/`,
	HeaderESLText: "ESL",
	HeaderESLUrl: `${YDR_PROTOCOL}//esl.${env}yourdictionary.com/`,
	HeaderGrammarText: "Grammar",
	HeaderGrammarUrl: `${YDR_PROTOCOL}//grammar.${env}yourdictionary.com/`,
	HeaderAbbreviationsText: "Abbreviations",
	HeaderAbbreviationsUrl: `${YDR_PROTOCOL}//abbreviations.${env}yourdictionary.com/`,
	HeaderBiographyText: "Biography",
	HeaderBiographyUrl: `${YDR_PROTOCOL}//biography.${env}yourdictionary.com/`,
	HeaderBooksLiteratureText: "Books & Literature",
	HeaderBooksLiteratureUrl: `${YDR_PROTOCOL}//reference.${env}yourdictionary.com/books-literature/`,
	HeaderForeignLanguagesText: "Foreign Languages",
	HeaderForeignLanguagesUrl: `${YDR_PROTOCOL}//reference.${env}yourdictionary.com/other-languages/`,
	HeaderResourcesText: "Resources",
	HeaderResourcesUrl: `${YDR_PROTOCOL}//reference.${env}yourdictionary.com/resources/`,
	HeaderSlideshowsText: "Slideshows",
	HeaderSlideshowsUrl: `${YDR_PROTOCOL}//www.${env}yourdictionary.com/articles/slideshow`,
	HeaderWordFinderText: "Word Finder",
	HeaderWordFinderUrl: "/",
	Header4Pics1WordText: "4 Pics 1 Word® Answers",
	Header4Pics1WordUrl: "/4pics1word/",
	HeaderAnagramSolverText: "Anagram Solver",
	HeaderAnagramSolverUrl: "/anagram-solver/",
	HeaderScrabbleDictionaryText: "Scrabble Dictionary",
	HeaderScrabbleDictionaryUrl: "/scrabble-dictionary/",
	HeaderUnscrambleText: "Unscramble",
	HeaderUnscrambleUrl: "/unscramble/",
	HeaderWordCookiesCheatText: "Word Cookies!® Cheat",
	HeaderWordCookiesCheatUrl: "/word-cookies/",
	HeaderScrabbleCheckerText: "Scrabble Checker",
	HeaderScrabbleCheckerUrl: "/scrabble-checker/",
	HeaderWWFCheatText: "Words with Friends® Cheat",
	HeaderWWFCheatUrl: "/words-with-friends-cheat/",
	HeaderMoreGamesText: "More Games",
	HeaderMoreGamesUrl: "/game-cheats/",
	HeaderWordListsText: "Word Lists",
	HeaderWordListsUrl: "/index/",
	HeaderYourDictionaryText: "YourDictionary",
	HeaderYourDictionaryUrl: `${YDR_PROTOCOL}//www.${env}yourdictionary.com/`,
	HeaderFeedbackText: "Feedback",
	HeaderFeedbackUrl: `${YDR_PROTOCOL}//www.surveymonkey.com/r/7ZWK2J6`,
	HeaderContactUsText: "Contact Us",
	HeaderContactUsUrl: "mailto:wordfinder@yourdictionary.com?subject=WordFinder Web Feedback",
	FooterAboutText: "About WordFinder",
	FooterAboutUrl: `${YDR_PROTOCOL}//wordfinder.yourdictionary.com/about/`,
	FooterAdvertisersText: "Advertisers",
	FooterAdvertisersUrl: `${YDR_PROTOCOL}//www.yourdictionary.com/about/adopp.html`,
	FooterContactUsText: "Contact Us",
	FooterContactUsUrl: `${YDR_PROTOCOL}//wordfinder.yourdictionary.com/about/#contact-us `,
	FooterPrivacyPolicyText: "Privacy Policy",
	FooterPrivacyPolicyUrl: `${YDR_PROTOCOL}//www.yourdictionary.com/about/privacy.html`,
	FooterTermsOfUseText: "Terms Of Use",
	FooterTermsOfUseUrl: `${YDR_PROTOCOL}//www.yourdictionary.com/about/terms-of-use.html`,
	FooterSuggestionBoxText: "Suggestion Box",
	DictionaryMenuSection17Text: "Wordle Solver",

	// TODO put these folks on the translation spreadseeht and import them when finished
	DictionaryMenuSection_WWF_AriaLabel: "Words With Friends®",
	DictionaryMenuSection_WWF_Text: "Words With Friends®",
	DictionaryMenuSection_WWF_TitleAttribute: "Words With Friends®",
	DictionaryMenuSection_US_AriaLabel: "Scrabble® US",
	DictionaryMenuSection_US_Text: "Scrabble® US",
	DictionaryMenuSection_US_TitleAttribute: "Scrabble® US",
	DictionaryMenuSection_UK_AriaLabel: "Scrabble® UK",
	DictionaryMenuSection_UK_Text: "Scrabble® UK",
	DictionaryMenuSection_UK_TitleAttribute: "Scrabble® UK",
	DictionaryMenuSection_ANAGRAM_AriaLabel: "Anagram Solver",
	DictionaryMenuSection_ANAGRAM_Text: "Anagram Solver",
	DictionaryMenuSection_ANAGRAM_TitleAttribute: "Anagram Solver",
	DictionaryMenuSection_PICS_AriaLabel: "4 Pics 1 Word®",
	DictionaryMenuSection_PICS_Text: "4 Pics 1 Word®",
	DictionaryMenuSection_PICS_TitleAttribute: "4 Pics 1 Word®",
	DictionaryMenuSection_JUM_AriaLabel: "Jumble Solver",
	DictionaryMenuSection_JUM_Text: "Jumble Solver",
	DictionaryMenuSection_JUM_TitleAttribute: "Jumble Solver",
	DictionaryMenuSection_CONNECT_AriaLabel: "Word Connect®",
	DictionaryMenuSection_CONNECT_Text: "Word Connect®",
	DictionaryMenuSection_CONNECT_TitleAttribute: "Word Connect®",
	DictionaryMenuSection_COOKIES_AriaLabel: "Word Cookies!®",
	DictionaryMenuSection_COOKIES_Text: "Word Cookies!®",
	DictionaryMenuSection_COOKIES_TitleAttribute: "Word Cookies!®",
	DictionaryMenuSection_CHU_AriaLabel: "Word Chums®",
	DictionaryMenuSection_CHU_Text: "Word Chums®",
	DictionaryMenuSection_CHU_TitleAttribute: "Word Chums®",
	DictionaryMenuSection_TWIST_AriaLabel: "Text Twist®",
	DictionaryMenuSection_TWIST_Text: "Text Twist®",
	DictionaryMenuSection_TWIST_TitleAttribute: "Text Twist®",
	DictionaryMenuSection_CROSS_AriaLabel: "CodyCross®",
	DictionaryMenuSection_CROSS_Text: "CodyCross®",
	DictionaryMenuSection_CROSS_TitleAttribute: "CodyCross®",
	DictionaryMenuSection_FEU_AriaLabel: "Wordfeud",
	DictionaryMenuSection_FEU_Text: "Wordfeud",
	DictionaryMenuSection_FEU_TitleAttribute: "Wordfeud",
	DictionaryMenuSection_BRAIN_AriaLabel: "WordBrain®",
	DictionaryMenuSection_BRAIN_Text: "WordBrain®",
	DictionaryMenuSection_BRAIN_TitleAttribute: "WordBrain®",
	DictionaryMenuSection_STORY_AriaLabel: "Words Story®",
	DictionaryMenuSection_STORY_Text: "Words Story®",
	DictionaryMenuSection_STORY_TitleAttribute: "Words Story®",
	DictionaryMenuSection_SWIPE_AriaLabel: "Word Swipe",
	DictionaryMenuSection_SWIPE_Text: "Word Swipe",
	DictionaryMenuSection_SWIPE_TitleAttribute: "Word Swipe",
	DictionaryMenuSection_ALL_AriaLabel: "All Games (No Points)",
	DictionaryMenuSection_ALL_Text: "All Games (No Points)",
	DictionaryMenuSection_ALL_TitleAttribute: "All Games (No Points)",
	DictionaryMenuSection_WS_Text: "Wordscapes®",
	DictionaryMenuSection_WS_TitleAttribute: "Wordscapes®",

	// New wordle labels: In the future these will come from the CMS so its good to have them here for the moment
	WordleInputLabelCorrectTiles: "Letters in the correct position",
	WordleInputLabelCorrectTilesSmall: "(green tiles)",
	WordleInputLabelIncludes: "Letters in the word",
	WordleInputLabelIncludesSmall: "(yellow and/or green tiles)",
	WordleInputLabelExcludes: "Letters not in the word",
	WordleInputLabelExcludesSmall: "(dark grey tiles)",

	// We will refactor the naming scheme we use for the navigation entries in the near future
	HeaderTextFiveLetterWords: "5 Letter Words",
	HeaderUrlFiveLetterWords: "/letter-words/5/",
	HeaderTitleAttributeFiveLetterWords: "5 Letter Words"
});

export default en;
